import { Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/ModeEdit";
import PhotoIcon from "@material-ui/icons/Photo";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";

import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";
import Paper from "@material-ui/core/Paper";
import { Category, Product } from "../api/model";
import orange from "@material-ui/core/colors/orange";
import blue from "@material-ui/core/colors/blue";
import red from "@material-ui/core/colors/red";
import { CategoryActions, ICategoryStore } from "src/store/category";
import { UploadImage } from "src/components/UploadImage";
import { green } from "@material-ui/core/colors";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  enableIcon: {
    color: green[900],
  },
  disableIcon: {
    color: red[900],
  },
  editIcon: {
    color: blue[500],
  },
  imageIcon: {
    color: orange[500],
  },
  imageColumn: {
    width: "50px",
    padding: "5px",
    textAlign: "center",
  },
  orderButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  orderButton: {
    width: 16,
    height: 16,
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface CategoryProps extends WithStyles<keyof typeof classesType> {
  actions: CategoryActions;
  data: ICategoryStore;
  companyId: number;
}

interface CategoryState {
  abm: {
    open: boolean;
    data: {
      category: Partial<Category>;
    };
  };
  photoEdit: {
    open: boolean;
    data: {
      category: Partial<Category>;
    };
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
  schema: any;
  image: any;
}

const schema: JSONSchema6 = {
  title: "Categoria",
  type: "object",
  properties: {
    category: {
      type: "object",
      title: "",
      required: ["name"],
      properties: {
        name: {
          type: "string",
          title: "Nombre",
        },
      },
    },
  },
};

const uiSchema: UiSchema = {
  category: {
    "ui:layout": [
      {
        name: { xs: 12 },
      },
    ],
  },
};

class CategoryView extends React.Component<CategoryProps, CategoryState> {
  static getDefaultEntity() {
    return { category: {} };
  }

  constructor(props: CategoryProps) {
    super(props);

    this.state = {
      abm: {
        open: false,
        data: CategoryView.getDefaultEntity(),
      },
      photoEdit: {
        open: false,
        data: CategoryView.getDefaultEntity(),
      },
      table: {
        data: [],
        sortBy: "position",
        sortDirection: "asc",
        columnData: [
          {
            path: "position",
            numeric: false,
            label: "Pos.",
            disablePadding: true,
          },
          {
            path: "foto",
            label: "Foto",
            draw: (cd: ColumnDefinition, data: Category) => {
              const imageTitle = this.getDataImage(data);
              return (
                <div>
                  <Tooltip title={imageTitle()}>
                    <img
                      src={data.photo}
                      className={this.props.classes.imageColumn}
                    />
                  </Tooltip>
                </div>
              );
            },
          },
          {
            path: "name",
            numeric: false,
            label: "Nombre",
            disablePadding: false,
          },
          {
            path: "state",
            numeric: false,
            label: "Estado",
            disablePadding: false,
          },
          {
            path: "",
            numeric: true,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: Category) => {
              return (
                <div style={{ minWidth: 200 }}>
                  <IconButton
                    className={this.props.classes.imageIcon}
                    aria-label="Agregar Imagen"
                    onClick={this.addImage(data)}
                  >
                    <Tooltip title="Agregar imagen">
                      <PhotoIcon />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    className={this.props.classes.editIcon}
                    aria-label="Editar"
                    onClick={this.edit(data)}
                  >
                    <Tooltip title="Editar">
                      <EditIcon />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    className={
                      data.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                    aria-label="Inhabilitar"
                    onClick={this.handleDisable(data)}
                  >
                    {data.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>
                </div>
              );
            },
          },
          {
            path: "",
            numeric: false,
            label: "",
            draw: (cd: ColumnDefinition, data: Category) => {
              return (
                <div className={this.props.classes.orderButtons}>
                  <IconButton
                    style={{ width: 24, height: 24 }}
                    onClick={this.movePosition(data, "up")}
                  >
                    <Tooltip title="Mover arriba">
                      <ExpandLessIcon
                        className={this.props.classes.orderButton}
                      />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    style={{ width: 24, height: 24 }}
                    onClick={this.movePosition(data, "down")}
                  >
                    <Tooltip title="Mover abajo">
                      <ExpandMoreIcon
                        className={this.props.classes.orderButton}
                      />
                    </Tooltip>
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
      image: null,
      schema: schema,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
    this.showPhotoEdit = this.showPhotoEdit.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
  }

  getDataImage(data: Category) {
    const img = new Image();
    img.src = data.photo;
    const extensionIndex = img.src.lastIndexOf(".");
    const extension =
      extensionIndex !== -1 ? img.src.substring(extensionIndex + 1) : "ninguno";

    const dato = (img.onload = () => {
      return (
        "Tamaño:" +
        img.width +
        " x " +
        img.height +
        "\n" +
        "Tipo: " +
        // "com/350/250 corresponde al placeHolder"
        (extension !== "com/350/250" ? extension.toUpperCase() : "WEB")
      );
    });
    return dato;
  }

  movePosition(
    data: Category,
    move: "up" | "down"
  ): React.MouseEventHandler<HTMLElement> | undefined {
    return (event: React.MouseEvent<HTMLElement>) => {
      if (move === "up") {
        this.props.actions.movePositionUp(this.props.companyId, data.id);
      } else {
        this.props.actions.movePositionDown(this.props.companyId, data.id);
      }
    };
  }

  handleDisable(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.props.actions.disable(this.props.companyId, data.id);
    };
  }

  addImage(data: Category) {
    console.log(data);
    return (event: any) => {
      this.setState({
        photoEdit: {
          open: true,
          data: {
            category: data,
          },
        },
      });
    };
  }

  edit(data: Category) {
    console.log("edit", data);
    return (event: React.MouseEvent<HTMLElement>) => {
      this.setState({
        abm: {
          open: true,
          data: {
            category: data,
          },
        },
      });
    };
  }

  handleSubmit(e: ISubmitEvent<any>) {
    if (e.formData.id) {
      return;
    }
    e.formData.category.photo = e.formData.category.photo
      ? e.formData.category.photo
      : "https://via.placeholder.com/250/250";
    e.formData.category.state = e.formData.category.state
      ? e.formData.category.state
      : "ACTIVE";
    this.props.actions.save(this.props.companyId, {
      ...e.formData,
    });
    this.hideDialog();
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  componentDidMount() {
    this.props.actions.fetch(this.props.companyId);
  }

  hideDialog() {
    this.setState({
      abm: { ...this.state.abm, open: false },
      photoEdit: { ...this.state.photoEdit, open: false },
    });
  }

  showDialog() {
    this.setState({
      abm: { data: CategoryView.getDefaultEntity(), open: true },
    });
  }

  showPhotoEdit() {
    this.setState({
      photoEdit: { data: CategoryView.getDefaultEntity(), open: true },
      image: null,
    });
  }

  handleImageChange(event: any) {
    console.log("AQUI", event.target.files!.item(0));
    this.setState({
      image: event.target.files!.item(0),
      photoEdit: {
        ...this.state.photoEdit,
        data: {
          category: {
            ...this.state.photoEdit.data.category,
            photo: URL.createObjectURL(event.target.files!.item(0)),
          },
        },
      },
    });
  }

  uploadImage() {
    const image: File = this.state.image;
    const categoryId = this.state.photoEdit.data.category.id!;
    const companyId = this.props.companyId;
    this.props.actions.uploadImage(companyId, categoryId, image);
  }

  render() {
    return (
      <Grid container spacing={24}>
        <Grid item sm={12} md={12}>
          <AsyncTable
            columnDefinition={this.state.table.columnData}
            title="Categorias"
            data={this.props.data.data}
            defaultOrder={{
              name: "position",
              direction: "asc",
            }}
            headerButtons={
              <Tooltip title="Agregar Categoria">
                <IconButton
                  aria-label="Agregar Categoria"
                  onClick={this.showDialog}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            }
          />
        </Grid>
        <Dialog open={this.state.abm.open} maxWidth="md" fullWidth={true}>
          <Paper className={this.props.classes.abm}>
            <EnhancedSchemaForm
              schema={this.state.schema}
              formData={this.state.abm.data}
              uiSchema={uiSchema}
              onSubmit={this.handleSubmit}
            >
              <div>
                <Button variant="contained" onClick={this.hideDialog}>
                  Cancelar
                </Button>
                &nbsp;
                <Button variant="contained" color="primary" type="submit">
                  Aceptar
                </Button>
              </div>
            </EnhancedSchemaForm>
          </Paper>
        </Dialog>
        <Dialog
          open={this.state.photoEdit.open}
          maxWidth="sm"
          fullWidth={false}
        >
          <Paper>
            <UploadImage
              value={this.state.photoEdit.data.category.photo}
              label="Subir Imagen Categoria"
              onImageChange={this.handleImageChange}
              onCancel={this.hideDialog}
              doUpload={this.uploadImage}
            />
          </Paper>
        </Dialog>
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: CategoryProps) => ({
  ...ownProps,
  data: state.category,
  companyId: state.auth.user!.companyId,
});

const styled = withStyles(styles as any)(CategoryView);
const connected = connect(
  mapStateToProps,
  bindActions(CategoryActions)
)(styled);

export default connected as ComponentClass<Partial<CategoryProps>>;



// WEBPACK FOOTER //
// ./src/pages/CategoryListPage.tsx